/* eslint-disable no-nested-ternary */
import { SourceTypes } from '../enums';

class RethinkUTIL {
  static getOpenChecks(checks: Map) {
    const fomattedChecks = new Map();
    checks &&
      checks.forEach((checkHeader, id) => {
        if (
          checkHeader.open &&
          (checkHeader.sourceType === SourceTypes.Default ||
            checkHeader.sourceType === SourceTypes.TextToPay ||
            checkHeader.sourceType === SourceTypes.WalkUp ||
            checkHeader.sourceType === SourceTypes.Online ||
            checkHeader.sourceType === SourceTypes.orderPay)
        ) {
          fomattedChecks.set(id, checkHeader);
        }
      });
    return fomattedChecks;
  }

  static getAllChecks(checks: Map, sortType) {
    const allChecks = [];
    checks.forEach(checkHeader => {
      allChecks.push(checkHeader);
    });
    return allChecks;
  }

  static getFireboardChecks(
    checks: Map,
    isKiosk,
    isCurbSideOrder,
    isOnline,
    isWalkUp,
    isTextToPay,
    isScanToPay,
    isTable,
    isTab,
  ) {
    const allChecks = [];
    const curbSideChecks = [];
    const kioskChecks = [];
    const onlineChecks = [];
    const walkUpChecks = [];
    const textToPayChecks = [];
    const scanToPayChecks = [];
    const tableChecks = [];
    const tabChecks = [];
    checks.forEach(checkHeader => {
      if (isCurbSideOrder && checkHeader.sourceType === 5) {
        curbSideChecks.push(checkHeader);
      } else if (isKiosk && checkHeader.sourceType === 1) {
        kioskChecks.push(checkHeader);
      } else if (isOnline && checkHeader.sourceType === 6) {
        onlineChecks.push(checkHeader);
      } else if (isWalkUp && checkHeader.sourceType === 7) {
        walkUpChecks.push(checkHeader);
      } else if (isTextToPay && checkHeader.sourceType === 8) {
        textToPayChecks.push(checkHeader);
      } else if (isScanToPay && checkHeader.sourceType === 9) {
        scanToPayChecks.push(checkHeader);
      } else if (isTable && checkHeader.sourceType === 0 && !checkHeader.tab) {
        tableChecks.push(checkHeader);
      } else if (isTab && checkHeader.sourceType === 0 && checkHeader.tab) {
        tabChecks.push(checkHeader);
      }
    });

    if (isKiosk) {
      return kioskChecks;
    }
    if (isCurbSideOrder) {
      return curbSideChecks;
    }
    if (isOnline) {
      return onlineChecks;
    }
    if (isWalkUp) {
      return walkUpChecks;
    }
    if (isTextToPay) {
      return textToPayChecks;
    }
    if (isScanToPay) {
      return scanToPayChecks;
    }
    if (isTable) {
      return tableChecks;
    }
    if (isTab) {
      return tabChecks;
    }
    return allChecks;
  }

  static getFireboardChecksBasedOnOrderType(checks: Map, orderTypes, selectedType) {
    const allChecks = [];
    checks.forEach(checkHeader => {
      orderTypes.forEach(eachType => {
        if (eachType.id === checkHeader.orderTypeId && eachType.name === selectedType) {
          allChecks.push(checkHeader);
        }
      });
    });
    return allChecks;
  }

  static getFireboardChecksBasedOnRevenueType(checks: Map, revenueTypes, selectedType) {
    const allChecks = [];
    checks.forEach(checkHeader => {
      revenueTypes.forEach(eachType => {
        if (eachType.id === checkHeader.revenueCenterId && eachType.name === selectedType) {
          allChecks.push(checkHeader);
        }
      });
    });
    return allChecks;
  }

  static getChecksForEmployee(checks: Map, employeeId) {
    const employeeChecks = [];
    if (checks && checks.size > 0) {
      checks &&
        checks.forEach(checkHeader => {
          if (checkHeader.employeeId === employeeId) {
            employeeChecks.push(checkHeader);
          }
        });
    }
    return employeeChecks;
  }

  static getStations(checks: Map) {
    const stations = {};
    checks &&
    checks.forEach(value => {
        let uniqueId = `check-${value.id}`;
        if (stations[uniqueId]) {
          stations[uniqueId].checks = stations[uniqueId].checks.concat(value);
        } else {
          stations[uniqueId] = {
            stationId: value.stationId,
            stationName: value.stationName,
            openDuration: 0,
            checks: [value],
            uniqueId,
          };
        }
      });
    return Object.values(stations);
  }

  static getStationsForEmployee(checks: Map, employeeId) {
    const stations = {};
    checks &&
      RethinkUTIL.getOpenChecks(checks).forEach(value => {
        if (value && value.employeeId === employeeId) {
          let uniqueId = `check-${value.id}`;
          if (stations[uniqueId]) {
            stations[uniqueId].checks = stations[uniqueId].checks.concat(value);
          } else {
            stations[uniqueId] = {
              stationId: value.stationId,
              stationName: value.stationName,
              openDuration: 0,
              checks: [value],
              uniqueId,
            };
          }
        }
      });
    return Object.values(stations);
  }

  static getTipsForEmployee(checks: Map, employeeId) {
    let tips = 0;
    let totalPayment = 0;
    if (checks && checks.size > 0) {
      checks.forEach(value => {
        if (value && value.employeeId === employeeId && value.payments !== undefined) {
          value.payments.forEach(payment => {
            if (payment.tipAmount !== undefined) {
              tips += payment.tipAmount;
            }
            if (payment.paymentAmount !== undefined) {
              totalPayment += payment.paymentAmount - value.taxAmount;
            }
          });
        }
      });
    }

    return { tips, tipPercent: totalPayment ? (tips * 100) / totalPayment : totalPayment };
  }
}

export default RethinkUTIL;
